var _rect, _rect2, _g, _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _rect3, _rect4, _g2, _path5, _path6, _path7, _path8, _circle4, _circle5, _circle6, _rect5, _rect6, _g3, _path9, _path10, _path11, _path12, _circle7, _circle8, _circle9, _rect7, _rect8, _g4, _path13, _path14, _path15, _path16, _circle10, _circle11, _circle12, _rect9, _rect10, _g5, _path17, _path18, _path19, _path20, _circle13, _circle14, _circle15, _rect11, _rect12, _g6, _path21, _path22, _path23, _path24, _circle16, _circle17, _circle18, _g7, _g8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 134,
    viewBox: "0 0 191 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 63.648,
    height: 63.648,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 67.248 57)",
    fill: "url(#paint0_linear_0_1)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.470738,
    width: 62.648,
    height: 62.648,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 67.6634 57.2491)",
    stroke: "white",
    strokeOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.648,
    height: 63.648,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 67.1543 57)",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.470738,
    width: 62.648,
    height: 62.648,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 67.5696 57.2491)",
    stroke: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.248 116.922L123.403 86.9609L123.403 103.999L67.2481 133.961L67.248 116.922Z",
    fill: "url(#paint1_linear_0_1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7481 133.127L67.748 117.222L122.903 87.7944L122.903 103.699L67.7481 133.127Z",
    stroke: "white",
    strokeOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0938 86.9609L67.2487 116.922L67.2487 133.999L11.0938 104.037L11.0938 86.9609Z",
    fill: "url(#paint2_linear_0_1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5938 103.738L11.5938 87.7944L66.7487 117.222L66.7487 133.166L11.5938 103.738Z",
    stroke: "white",
    strokeOpacity: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.38675,
    cy: 2.38675,
    r: 2.38675,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 52 115)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.38675,
    cy: 2.38675,
    r: 2.38675,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 44 111)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.38675,
    cy: 2.38675,
    r: 2.38675,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 36 106)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 63.648,
    height: 63.648,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 67.248 34)",
    fill: "url(#paint3_linear_0_1)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.470738,
    width: 62.648,
    height: 62.648,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 67.6634 34.2491)",
    stroke: "white",
    strokeOpacity: 0.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.648,
    height: 63.648,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 67.1543 34)",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.470738,
    width: 62.648,
    height: 62.648,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 67.5696 34.2491)",
    stroke: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.248 93.9225L123.403 63.9609L123.403 80.999L67.2481 110.961L67.248 93.9225Z",
    fill: "url(#paint4_linear_0_1)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7481 110.127L67.748 94.2224L122.903 64.7944L122.903 80.6991L67.7481 110.127Z",
    stroke: "white",
    strokeOpacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0938 63.9609L67.2487 93.9225L67.2487 110.999L11.0938 81.0375L11.0938 63.9609Z",
    fill: "url(#paint5_linear_0_1)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5938 80.7375L11.5938 64.7944L66.7487 94.2224L66.7487 110.166L11.5938 80.7375Z",
    stroke: "white",
    strokeOpacity: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.38675,
    cy: 2.38675,
    r: 2.38675,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 52 92)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.38675,
    cy: 2.38675,
    r: 2.38675,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 44 88)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.38675,
    cy: 2.38675,
    r: 2.38675,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 36 83)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 63.648,
    height: 63.648,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 67.248 11)",
    fill: "url(#paint6_linear_0_1)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.470738,
    width: 62.648,
    height: 62.648,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 67.6634 11.2491)",
    stroke: "white",
    strokeOpacity: 0.5
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.648,
    height: 63.648,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 67.1543 11)",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.470738,
    width: 62.648,
    height: 62.648,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 67.5696 11.2491)",
    stroke: "white"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.248 70.9225L123.403 40.9609L123.403 57.999L67.2481 87.9606L67.248 70.9225Z",
    fill: "url(#paint7_linear_0_1)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7481 87.1271L67.748 71.2224L122.903 41.7944L122.903 57.6991L67.7481 87.1271Z",
    stroke: "white",
    strokeOpacity: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0938 40.9609L67.2487 70.9225L67.2487 87.999L11.0938 58.0375L11.0938 40.9609Z",
    fill: "url(#paint8_linear_0_1)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5938 57.7375L11.5938 41.7944L66.7487 71.2224L66.7487 87.1655L11.5938 57.7375Z",
    stroke: "white",
    strokeOpacity: 0.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.38675,
    cy: 2.38675,
    r: 2.38675,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 52 69)",
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.38675,
    cy: 2.38675,
    r: 2.38675,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 44 65)",
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.38675,
    cy: 2.38675,
    r: 2.38675,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 36 60)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 39.8447,
    height: 39.8447,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 145.213 81.7969)",
    fill: "url(#paint9_linear_0_1)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.470738,
    width: 38.8447,
    height: 38.8447,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 145.628 82.046)",
    stroke: "white",
    strokeOpacity: 0.5
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.8447,
    height: 39.8447,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 145.154 81.7969)",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.470738,
    width: 38.8447,
    height: 38.8447,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 145.57 82.046)",
    stroke: "white"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M145.213 119.309L180.367 100.553L180.367 111.219L145.213 129.975L145.213 119.309Z",
    fill: "url(#paint10_linear_0_1)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M145.713 129.142L145.713 119.609L179.867 101.386L179.867 110.919L145.713 129.142Z",
    stroke: "white",
    strokeOpacity: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M110.059 100.553L145.212 119.309L145.213 129.999L110.059 111.243L110.059 100.553Z",
    fill: "url(#paint11_linear_0_1)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M110.559 110.943L110.559 101.386L144.712 119.609L144.713 129.166L110.559 110.943Z",
    stroke: "white",
    strokeOpacity: 0.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.49415,
    cy: 1.49415,
    r: 1.49415,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 135.666 118.105)",
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.49415,
    cy: 1.49415,
    r: 1.49415,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 130.658 115.602)",
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.49415,
    cy: 1.49415,
    r: 1.49415,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 125.65 112.471)",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 39.8447,
    height: 39.8447,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 145.213 67.3984)",
    fill: "url(#paint12_linear_0_1)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.470738,
    width: 38.8447,
    height: 38.8447,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 145.628 67.6476)",
    stroke: "white",
    strokeOpacity: 0.5
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.8447,
    height: 39.8447,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 145.154 67.3984)",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.470738,
    width: 38.8447,
    height: 38.8447,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 145.57 67.6476)",
    stroke: "white"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M145.213 104.911L180.367 86.1543L180.367 96.8204L145.213 115.577L145.213 104.911Z",
    fill: "url(#paint13_linear_0_1)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M145.713 114.743L145.713 105.211L179.867 86.9878L179.867 96.5205L145.713 114.743Z",
    stroke: "white",
    strokeOpacity: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M110.059 86.1543L145.212 104.911L145.213 115.601L110.059 96.8445L110.059 86.1543Z",
    fill: "url(#paint14_linear_0_1)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M110.559 96.5445L110.559 86.9878L144.712 105.211L144.713 114.767L110.559 96.5445Z",
    stroke: "white",
    strokeOpacity: 0.5
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.49415,
    cy: 1.49415,
    r: 1.49415,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 135.666 103.707)",
    fill: "white"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.49415,
    cy: 1.49415,
    r: 1.49415,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 130.658 101.203)",
    fill: "white"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.49415,
    cy: 1.49415,
    r: 1.49415,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 125.65 98.0723)",
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 39.8447,
    height: 39.8447,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 145.213 53)",
    fill: "url(#paint15_linear_0_1)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.470738,
    width: 38.8447,
    height: 38.8447,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 145.628 53.2491)",
    stroke: "white",
    strokeOpacity: 0.5
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.8447,
    height: 39.8447,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 145.154 53)",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.470738,
    width: 38.8447,
    height: 38.8447,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 145.57 53.2491)",
    stroke: "white"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M145.213 90.5123L180.367 71.7559L180.367 82.422L145.213 101.178L145.213 90.5123Z",
    fill: "url(#paint16_linear_0_1)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M145.713 100.345L145.713 90.8122L179.867 72.5894L179.867 82.122L145.713 100.345Z",
    stroke: "white",
    strokeOpacity: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M110.059 71.7559L145.212 90.5123L145.213 101.202L110.059 82.4461L110.059 71.7559Z",
    fill: "url(#paint17_linear_0_1)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M110.559 82.1461L110.559 72.5894L144.712 90.8122L144.713 100.369L110.559 82.1461Z",
    stroke: "white",
    strokeOpacity: 0.5
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.49415,
    cy: 1.49415,
    r: 1.49415,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 135.666 89.3086)",
    fill: "white"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.49415,
    cy: 1.49415,
    r: 1.49415,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 130.658 86.8047)",
    fill: "white"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.49415,
    cy: 1.49415,
    r: 1.49415,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 125.65 83.6738)",
    fill: "white"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.1108 40.4255L76.4829 37.3239C78.2888 36.2812 78.2888 34.5907 76.4829 33.5481V33.5481C74.6769 32.5054 71.7489 32.5054 69.9429 33.5481L64.5708 36.6496",
    stroke: "#E84AF8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2467 37.4144L57.8746 40.5159C56.0686 41.5586 56.0686 43.2491 57.8746 44.2918V44.2918C59.6805 45.3344 62.6085 45.3344 64.4145 44.2918L69.7866 41.1902",
    stroke: "#E84AF8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7773 36.8418L63.1713 41.2332",
    stroke: "#E84AF8",
    strokeWidth: 2
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.323 73.1225L152.618 70.643C154.062 69.8095 154.062 68.458 152.618 67.6245V67.6245C151.174 66.791 148.834 66.791 147.39 67.6245L143.095 70.104",
    stroke: "#E84AF8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.038 70.7153L137.743 73.1949C136.3 74.0284 136.3 75.3798 137.743 76.2134V76.2134C139.187 77.0469 141.528 77.0469 142.972 76.2134L147.266 73.7339",
    stroke: "#E84AF8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.059 70.2578L141.978 73.7684",
    stroke: "#E84AF8",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_1",
    x: 0.6,
    y: 46.6,
    width: 133.109,
    height: 80.7238,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.2,
    result: "effect1_foregroundBlur_0_1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_0_1",
    x: 0.6,
    y: 23.6,
    width: 133.109,
    height: 80.7238,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.2,
    result: "effect1_foregroundBlur_0_1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_0_1",
    x: 0.6,
    y: 0.6,
    width: 133.109,
    height: 80.7238,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.2,
    result: "effect1_foregroundBlur_0_1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_0_1",
    x: 99.6,
    y: 71.3969,
    width: 91.1086,
    height: 58.3137,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.2,
    result: "effect1_foregroundBlur_0_1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_0_1",
    x: 99.6,
    y: 56.9984,
    width: 91.1086,
    height: 58.3137,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.2,
    result: "effect1_foregroundBlur_0_1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_0_1",
    x: 99.6,
    y: 42.6,
    width: 91.1086,
    height: 58.3137,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.2,
    result: "effect1_foregroundBlur_0_1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_0_1",
    x: 51.2949,
    y: 28.0586,
    width: 31.7676,
    height: 21.7227,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.847163 0 0 0 0 0.239926 0 0 0 0 0.908655 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_0_1",
    x: 131.436,
    y: 62.293,
    width: 27.4902,
    height: 19.252,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.956863 0 0 0 0 0.364706 0 0 0 0 0.826588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: -7.85989,
    y1: 16.2789,
    x2: 6.22548,
    y2: 70.3201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#E478EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E190EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFA7E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 60.3135,
    y1: 98.9818,
    x2: 69.1879,
    y2: 139.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#E478EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E190EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFA7E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 4.15918,
    y1: 98.9916,
    x2: 13.0474,
    y2: 139.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#E478EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E190EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFA7E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: -7.85989,
    y1: 16.2789,
    x2: 6.22548,
    y2: 70.3201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#E478EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E190EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFA7E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_1",
    x1: 60.3135,
    y1: 75.9818,
    x2: 69.1879,
    y2: 116.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#E478EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E190EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFA7E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_1",
    x1: 4.15918,
    y1: 75.9916,
    x2: 13.0474,
    y2: 116.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#E478EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E190EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFA7E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_1",
    x1: -7.85989,
    y1: 16.2789,
    x2: 6.22548,
    y2: 70.3201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#E478EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E190EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFA7E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_0_1",
    x1: 60.3135,
    y1: 52.9818,
    x2: 69.1879,
    y2: 93.6624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#E478EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E190EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFA7E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_0_1",
    x1: 4.15918,
    y1: 52.9916,
    x2: 13.0474,
    y2: 93.7025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#E478EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E190EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFA7E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_0_1",
    x1: -4.92042,
    y1: 10.1909,
    x2: 3.89725,
    y2: 44.0215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#E478EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E190EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFA7E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_0_1",
    x1: 140.872,
    y1: 108.078,
    x2: 146.427,
    y2: 133.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#E478EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E190EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFA7E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_0_1",
    x1: 105.717,
    y1: 108.084,
    x2: 111.282,
    y2: 133.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#E478EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E190EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFA7E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_0_1",
    x1: -4.92042,
    y1: 10.1909,
    x2: 3.89725,
    y2: 44.0215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#E478EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E190EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFA7E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_0_1",
    x1: 140.872,
    y1: 93.6795,
    x2: 146.427,
    y2: 119.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#E478EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E190EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFA7E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_0_1",
    x1: 105.717,
    y1: 93.6857,
    x2: 111.282,
    y2: 119.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#E478EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E190EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFA7E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_0_1",
    x1: -4.92042,
    y1: 10.1909,
    x2: 3.89725,
    y2: 44.0215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#E478EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E190EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFA7E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_0_1",
    x1: 140.872,
    y1: 79.2811,
    x2: 146.427,
    y2: 104.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#E478EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E190EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFA7E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_0_1",
    x1: 105.717,
    y1: 79.2873,
    x2: 111.282,
    y2: 104.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#E478EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E190EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFA7E5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartContract);
export default __webpack_public_path__ + "static/media/smart-contract.1c74d3d9a24d5f5bbcd8e5202b848900.svg";
export { ForwardRef as ReactComponent };